import styled from 'styled-components';
import { Button } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const CardContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	margin-bottom: 10px;
`;

export const CardContainerLancamento = styled.button`
	display: flex;
	flex-direction: column;
	background: none;
	border: none;
	width: 100%;
`;

export const CardCred = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const CardLancamento = styled.div`
	display: flex;
	width: 100%;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid ${color.grayMedium};
`;

export const CardLancamentoUnico = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const ImageBanner = styled.img`
	display: flex;
`

export const Details = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
`;

export const DetailsLancamento = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	align-items: flex-start;
`;

export const DetailsLancamentoRight = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	align-items: flex-end;
`;

export const DetailsLancamentoMiddle = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	align-items: flex-end;
`;

export const ButtonStyle = styled(Button)`
	width: 100%;
	font-size: 12px;
	border-radius: 15px;
	padding: 0;
	border-color: transparent;
`;

export const ButtonStyleDetails = styled(Button)`
	margin: 0;
	padding: 0;
	font-size: 12px;
	border-color: transparent;
	text-decoration: underline;
`;
